module.exports = __webpack_public_path__ + "static/img/a118.0b580c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a118.jpg
// module id = tCb6
// module chunks = 0